import {useParams} from "react-router-dom"
import {Suspense} from "react"
import {ErrorBoundary} from "react-error-boundary"

import {CustomerStatuses} from "./CustomerStatuses"
import {SecureCodeNotFound} from "./SecureCodeNotFound"
import {SecureCodeSkeleton} from "./SecureCodeSkeleton"

import {ErrorPage} from "@indebted/components/Error"
import {useCustomerFindQuery} from "@indebted/api/customer/customerFind"
import {ApiError} from "@indebted/api/ApiError"

function SecureCodeLandingPage() {
	const {secureCode} = useParams()

	return (
		<div data-testid="secure-code-landing-page">
			<ErrorBoundary fallbackRender={({error}) => <ErrorFallback error={error} secureCode={secureCode!} />}>
				<Suspense fallback={<SecureCodeSkeleton />}>
					<SecureCodeLandingPageLoader />
				</Suspense>
			</ErrorBoundary>
		</div>
	)
}

function SecureCodeLandingPageLoader() {
	const {secureCode} = useParams()
	const {data: result} = useCustomerFindQuery(secureCode!)

	return <CustomerStatuses result={result} secureCode={secureCode!} />
}

function ErrorFallback({error, secureCode}: {error: any; secureCode: string}) {
	if (error instanceof ApiError && error.Status === 404) {
		return <SecureCodeNotFound secureCode={secureCode} />
	}

	return <ErrorPage message={error.Message || error.message} error={error} />
}

export {SecureCodeLandingPage}
